import { useContext } from "react";
import client from "../httpClient";
import { UIStoreContext } from "../../context";

interface PerformanceReportStats {
  detection_count: number;
  daily_detection_max: number;
  daily_detection_avg: number;
  classes_count: {
    Person: number;
    Animal: number;
    Obstacle: number;
    Bike: number;
    Locomotive: number;
    Car: number;
    Truck: number;
    Train: number;
    Wagon: number;
    Back_Switch: number;
    End_Of_Rail: number;
  };
  avg_range: number;
  max_range: number;
  wakeups: number;
}

export default {
  GetPerformanceReportStats: (): PerformanceReportStats => {
    const uiStore = useContext(UIStoreContext);
    const response = client.Get(
      "performanceReportStats",
      [
        "performanceReportStats",
        uiStore.getStartDate(),
        uiStore.getEndDate(),
        uiStore.getSelectedSystem(),
        uiStore.getSelectedClass(),
        uiStore.getDetectionTableSortDirection(),
        uiStore.getLatLngBounds(),
      ],
      {
        start_date: uiStore.getStartDate().toISO(),
        end_date: uiStore.getEndDate().toISO(),
        system_id: uiStore.getSelectedSystem(),
        classification_filter: uiStore.getSelectedClass(),
        order: uiStore.getDetectionTableSortDirection(),
        label: uiStore.getDateFilter().label,
        bounds: uiStore.getLatLngBounds(),
      },
      {
        staleTime: 6000 * 30,
        enabled: uiStore.getSelectedSystem() !== "",
        keepPreviousData: true,
      }
    );
    if (response.isSuccess) {
      return response.data;
    } else {
      return {
        detection_count: 0,
        daily_detection_max: 0,
        daily_detection_avg: 0,
        classes_count: {
          Person: 0,
          Animal: 0,
          Obstacle: 0,
          Bike:0,
          Train:0,
          Locomotive: 0,
          Car: 0,
          Truck:0,
          Wagon: 0,
          Back_Switch: 0,
          End_Of_Rail: 0,
        },
        avg_range: 0,
        max_range: 0,
        wakeups: 0,
      };
    }
  },
};
